/* Sam Everything — comportamiento del tema */
document.documentElement.classList.add('js');
window.__seAnim = true; /* avisa al seguro de animaciones que este archivo cargó */

document.addEventListener('DOMContentLoaded', () => {
  /* ---------- Menú desplegable (escritorio) ---------- */
  const megaButtons = document.querySelectorAll('[data-mega-toggle]');
  const closeAllMegas = (except) => {
    megaButtons.forEach((btn) => {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  };
  megaButtons.forEach((btn) => {
    const panel = document.getElementById(btn.getAttribute('aria-controls'));
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = btn.getAttribute('aria-expanded') === 'true';
      closeAllMegas(btn);
      btn.setAttribute('aria-expanded', String(!open));
      if (panel) panel.hidden = open;
    });
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.mega') && !e.target.closest('[data-mega-toggle]')) closeAllMegas();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const openBtn = document.querySelector('[data-mega-toggle][aria-expanded="true"]');
      closeAllMegas();
      if (openBtn) openBtn.focus();
      closeMobileNav();
    }
  });

  /* ---------- Menú móvil ---------- */
  const mobileNav = document.getElementById('MobileNav');
  const mobileOpen = document.querySelector('[data-mobile-open]');
  const mobileClose = document.querySelector('[data-mobile-close]');
  function closeMobileNav() {
    if (!mobileNav || mobileNav.hidden) return;
    mobileNav.hidden = true;
    document.body.style.overflow = '';
    if (mobileOpen) { mobileOpen.setAttribute('aria-expanded', 'false'); mobileOpen.focus(); }
  }
  if (mobileOpen && mobileNav) {
    mobileOpen.addEventListener('click', () => {
      mobileNav.hidden = false;
      document.body.style.overflow = 'hidden';
      mobileOpen.setAttribute('aria-expanded', 'true');
      if (mobileClose) mobileClose.focus();
    });
  }
  if (mobileClose) mobileClose.addEventListener('click', closeMobileNav);

  /* ---------- Cantidad (+ / −) con límite de inventario ---------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    const plus = wrap.querySelector('button[data-step="1"]');
    const minus = wrap.querySelector('button[data-step="-1"]');
    const getMax = () => { const m = parseInt(input.max, 10); return isNaN(m) ? Infinity : m; };
    const getMin = () => parseInt(input.min || '0', 10);
    /* Ajusta el valor a [min, max]. Devuelve true si tuvo que cambiarlo. */
    const clamp = () => {
      const min = getMin(), max = getMax();
      let v = parseInt(input.value, 10);
      if (isNaN(v)) v = min;
      const nv = Math.min(max, Math.max(min, v));
      const changed = String(nv) !== input.value;
      input.value = nv;
      if (plus) plus.disabled = nv >= max;
      if (minus) minus.disabled = nv <= min;
      return { changed, hitMax: v > max };
    };
    input.addEventListener('se:sync', () => clamp());
    input.addEventListener('change', () => {
      const r = clamp();
      if (r.hitMax) input.dispatchEvent(new CustomEvent('se:limit', { bubbles: true }));
    });
    wrap.querySelectorAll('button[data-step]').forEach((b) => {
      b.addEventListener('click', () => {
        const before = input.value;
        input.value = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10);
        const r = clamp();
        if (r.hitMax) input.dispatchEvent(new CustomEvent('se:limit', { bubbles: true }));
        if (input.value !== before) input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    clamp();
  });

  /* Carrito: al cambiar la cantidad se actualiza solo */
  const cartForm = document.getElementById('CartForm');
  if (cartForm) {
    let t;
    cartForm.querySelectorAll('input[name="updates[]"]').forEach((i) => {
      i.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => cartForm.submit(), 450); });
    });
  }

  /* ---------- Filtros de colección ---------- */
  const filterForm = document.getElementById('FilterForm');
  if (filterForm) {
    const submitFilters = () => {
      const params = new URLSearchParams(new FormData(filterForm));
      for (const [k, v] of [...params.entries()]) { if (v === '') params.delete(k); }
      window.location.search = params.toString();
    };
    filterForm.querySelectorAll('input[type="checkbox"], select').forEach((el) => el.addEventListener('change', submitFilters));
    let pt;
    filterForm.querySelectorAll('input[type="number"]').forEach((el) => el.addEventListener('input', () => { clearTimeout(pt); pt = setTimeout(submitFilters, 900); }));
  }
  const sortSelect = document.getElementById('SortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSelect.value);
      params.delete('page');
      window.location.search = params.toString();
    });
  }
  const filtersToggle = document.querySelector('[data-filters-toggle]');
  const filtersPanel = document.querySelector('.filters');
  if (filtersToggle && filtersPanel) {
    if (window.matchMedia('(max-width: 989px)').matches) filtersPanel.dataset.collapsed = 'true';
    filtersToggle.addEventListener('click', () => {
      const collapsed = filtersPanel.dataset.collapsed === 'true';
      filtersPanel.dataset.collapsed = String(!collapsed);
      filtersToggle.setAttribute('aria-expanded', String(collapsed));
    });
  }

  /* ---------- Página de producto: galería y variantes ---------- */
  const productRoot = document.querySelector('[data-product]');
  let galleryGoToMedia = null;
  if (productRoot) {
    const gallery = productRoot.querySelector('[data-gallery]');
    if (gallery) {
      const track = gallery.querySelector('[data-track]');
      const slides = [...track.querySelectorAll('[data-slide]')];
      const thumbs = [...gallery.querySelectorAll('[data-thumb]')];
      const dots = [...gallery.querySelectorAll('[data-dot]')];
      const prev = gallery.querySelector('[data-gallery-prev]');
      const next = gallery.querySelector('[data-gallery-next]');
      let index = -1, ticking = false;
      const width = () => track.clientWidth || 1;

      const goTo = (i, smooth) => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * width(), behavior: smooth === false ? 'auto' : 'smooth' });
      };

      /* Videos: se reproducen solos (sin sonido) cuando están a la vista */
      const handleMedia = (i) => {
        slides.forEach((sl, k) => {
          const v = sl.querySelector('video');
          if (v) { if (k === i) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); } else v.pause(); }
          const f = sl.querySelector('iframe[data-src]');
          if (f) { if (k === i) { if (!f.getAttribute('src')) f.setAttribute('src', f.dataset.src); } else if (f.getAttribute('src')) f.removeAttribute('src'); }
        });
      };

      const setActive = (i, quiet) => {
        if (i === index) return;
        index = i;
        thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
        dots.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        handleMedia(i);
        if (!quiet && thumbs[i] && thumbs[i].parentElement) {
          const box = thumbs[i].parentElement;
          if (box.scrollWidth > box.clientWidth) box.scrollTo({ left: thumbs[i].offsetLeft - (box.clientWidth - thumbs[i].offsetWidth) / 2, behavior: 'smooth' });
        }
      };

      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; setActive(Math.round(track.scrollLeft / width())); });
      }, { passive: true });
      thumbs.forEach((t, k) => t.addEventListener('click', () => goTo(k)));
      if (prev) prev.addEventListener('click', () => goTo(index - 1));
      if (next) next.addEventListener('click', () => goTo(index + 1));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index - 1); }
      });

      /* Zoom: al tocar una foto se abre grande; toca de nuevo para acercar, y en el celular se puede pellizcar */
      const imgSlides = slides.filter((sl) => sl.querySelector('img'));
      if (imgSlides.length) {
        const lb = document.createElement('dialog');
        lb.className = 'zoom-dialog';
        lb.setAttribute('aria-label', 'Foto ampliada');
        lb.innerHTML = '<button type="button" class="zoom__btn zoom__close" aria-label="Cerrar">&times;</button>' +
          '<button type="button" class="zoom__btn zoom__prev" aria-label="Foto anterior">&#8249;</button>' +
          '<button type="button" class="zoom__btn zoom__next" aria-label="Foto siguiente">&#8250;</button>' +
          '<div class="zoom__stage"><img alt="" draggable="false"></div>' +
          '<p class="zoom__hint">Toca la foto para acercar</p>';
        document.body.appendChild(lb);
        const stage = lb.querySelector('.zoom__stage'), zimg = stage.querySelector('img');
        const zprev = lb.querySelector('.zoom__prev'), znext = lb.querySelector('.zoom__next');
        let zi = 0;
        const big = (src) => (src || '').replace(/width=\d+/, 'width=2400');
        const show = (k) => {
          zi = Math.max(0, Math.min(imgSlides.length - 1, k));
          const im = imgSlides[zi].querySelector('img');
          zimg.src = big(im.currentSrc || im.src); zimg.alt = im.alt || '';
          stage.classList.remove('is-zoomed'); stage.scrollTo(0, 0);
          zprev.hidden = zi === 0; znext.hidden = zi === imgSlides.length - 1;
        };
        const openZoom = (k) => { show(k); if (!lb.open) lb.showModal(); };
        zimg.addEventListener('click', () => {
          const z = stage.classList.toggle('is-zoomed');
          lb.classList.toggle('is-zoomed', z);
          if (z) { stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2; stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2; }
        });
        lb.querySelector('.zoom__close').addEventListener('click', () => lb.close());
        zprev.addEventListener('click', () => show(zi - 1));
        znext.addEventListener('click', () => show(zi + 1));
        lb.addEventListener('click', (e) => { if (e.target === lb || e.target === stage) lb.close(); });
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') show(zi + 1);
          if (e.key === 'ArrowLeft') show(zi - 1);
        });
        lb.addEventListener('close', () => { stage.classList.remove('is-zoomed'); lb.classList.remove('is-zoomed'); });
        let down = null;
        track.addEventListener('pointerdown', (e) => { down = { x: e.clientX, y: e.clientY }; });
        track.addEventListener('click', (e) => {
          const sl = e.target.closest('[data-slide]');
          if (!sl || !sl.querySelector('img') || e.target.closest('button')) return;
          if (down && Math.hypot(e.clientX - down.x, e.clientY - down.y) > 8) return;
          openZoom(imgSlides.indexOf(sl));
        });
        track.querySelectorAll('img').forEach((im) => { im.style.cursor = 'zoom-in'; });
      }

      /* Arrastrar con el mouse (en el celular ya se desliza con el dedo) */
      let drag = null;
      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('video, iframe, button')) return;
        drag = { x: e.clientX, left: track.scrollLeft, moved: false };
      });
      window.addEventListener('pointermove', (e) => {
        if (!drag) return;
        const dx = e.clientX - drag.x;
        if (Math.abs(dx) > 4 && !drag.moved) { drag.moved = true; track.style.scrollSnapType = 'none'; track.style.cursor = 'grabbing'; }
        if (drag.moved) track.scrollLeft = drag.left - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!drag) return;
        const moved = drag.moved; drag = null;
        if (moved) { track.style.scrollSnapType = ''; track.style.cursor = ''; goTo(Math.round(track.scrollLeft / width())); }
      });
      window.addEventListener('resize', () => goTo(index < 0 ? 0 : index, false));

      galleryGoToMedia = (mediaId) => {
        const i = slides.findIndex((sl) => String(sl.dataset.mediaId) === String(mediaId));
        if (i > -1) goTo(i);
      };
      const start = parseInt(gallery.dataset.start || '0', 10) || 0;
      requestAnimationFrame(() => { goTo(start, false); setActive(start, true); });
      if (slides.length === 1) setActive(0, true);
    }

    const variantsEl = productRoot.querySelector('[data-variants]');
    const idInput = productRoot.querySelector('input[name="id"]');
    const priceEl = productRoot.querySelector('[data-price]');
    const addBtn = productRoot.querySelector('[data-add-button]');
    const qtyInput = productRoot.querySelector('[data-qty-input]');
    const qtyHint = productRoot.querySelector('[data-qty-hint]');
    if (variantsEl && idInput) {
      const variants = JSON.parse(variantsEl.textContent);
      const money = (cents) => (cents / 100).toLocaleString('es-DO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      let maxAdd = Infinity, currentInv = null;

      /* Límite de unidades según el inventario (menos lo que ya está en el carrito) */
      const applyStock = (v) => {
        maxAdd = Infinity; currentInv = null;
        if (v && v.available && v.inventory != null) {
          currentInv = v.inventory;
          maxAdd = Math.max(0, v.inventory - (v.in_cart || 0));
        }
        if (qtyInput) {
          if (maxAdd === Infinity) qtyInput.removeAttribute('max');
          else qtyInput.max = String(Math.max(1, maxAdd));
          qtyInput.dispatchEvent(new CustomEvent('se:sync'));
        }
        if (qtyHint) {
          if (maxAdd === Infinity) { qtyHint.hidden = true; }
          else if (maxAdd === 0) { qtyHint.hidden = false; qtyHint.textContent = 'Ya tienes en tu carrito todas las unidades disponibles ♡'; }
          else if (maxAdd <= 5) { qtyHint.hidden = false; qtyHint.textContent = maxAdd === 1 ? '¡Solo queda 1 disponible!' : '¡Solo quedan ' + maxAdd + ' disponibles!'; }
          else { qtyHint.hidden = true; }
        }
        if (v && v.available && maxAdd === 0 && addBtn) {
          addBtn.type = 'button'; addBtn.disabled = true; addBtn.textContent = 'Ya está todo en tu carrito';
        }
      };
      if (qtyInput) qtyInput.addEventListener('se:limit', () => {
        if (!qtyHint || maxAdd === Infinity) return;
        qtyHint.hidden = false;
        qtyHint.textContent = currentInv === 1 || maxAdd === 1 ? 'Solo hay 1 disponible.' : 'Solo hay ' + maxAdd + ' disponibles para añadir.';
      });

      const update = () => {
        const chosen = [...productRoot.querySelectorAll('[data-option-index]')]
          .sort((a, b) => a.dataset.optionIndex - b.dataset.optionIndex)
          .map((g) => { const c = g.querySelector('input:checked'); return c ? c.value : null; });
        const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
        if (!v) { addBtn.type = 'button'; addBtn.disabled = true; addBtn.textContent = 'No disponible'; return; }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        const notifyOn = addBtn.dataset.notifyEnabled === 'true';
        const soon = productRoot.querySelector('[data-soon]');
        const soldout = productRoot.querySelector('[data-soldout]');
        if (soon) soon.hidden = v.available;
        if (soldout) soldout.hidden = v.available;
        if (v.available) {
          addBtn.type = 'submit'; addBtn.disabled = false; addBtn.textContent = 'Añadir al carrito';
        } else if (notifyOn) {
          addBtn.type = 'button'; addBtn.disabled = false; addBtn.textContent = addBtn.dataset.notifyLabel || 'Avísame cuando llegue';
        } else {
          addBtn.type = 'submit'; addBtn.disabled = true; addBtn.textContent = 'No disponible';
        }
        applyStock(v);
        const tagsEl = document.querySelector('[data-notify-tags]');
        if (tagsEl) tagsEl.value = tagsEl.dataset.baseTags + ', restock-v' + v.id;
        if (v.media_id && galleryGoToMedia) galleryGoToMedia(v.media_id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };
      productRoot.querySelectorAll('[data-option-index] input').forEach((i) => i.addEventListener('change', update));
      applyStock(variants.find((x) => String(x.id) === String(idInput.value)));
    }
  }

  /* ---------- Producto: aviso de reposición y ventana de devoluciones ---------- */
  (function () {
    const root = document.querySelector('[data-product]');
    if (!root) return;
    const btn = root.querySelector('[data-add-button]');
    const panel = document.querySelector('form[data-notify]');
    if (panel) {
      const posted = panel.querySelector('.form-message--success');
      panel.hidden = !posted;
      if (btn) btn.addEventListener('click', () => {
        if (btn.type !== 'button') return;
        panel.hidden = false;
        const em = panel.querySelector('input[type="email"]');
        if (em) em.focus();
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
    const dlg = root.querySelector('[data-policy-dialog]');
    const open = root.querySelector('[data-policy-open]');
    if (dlg && open && typeof dlg.showModal === 'function') {
      open.addEventListener('click', () => dlg.showModal());
      dlg.querySelector('[data-policy-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
  })();

  /* ---------- Elegir tono / variante sin salir de la página ---------- */
  (function () {
    const qa = document.getElementById('QuickAdd');
    if (!qa || typeof qa.showModal !== 'function') return;
    const $ = (s) => qa.querySelector(s);
    const img = $('[data-qa-img]'), title = $('[data-qa-title]'), price = $('[data-qa-price]');
    const optsBox = $('[data-qa-options]'), msg = $('[data-qa-msg]');
    const addBtn = $('[data-qa-add]'), cartLink = $('[data-qa-cart]'), moreLink = $('[data-qa-link]');
    const root = qa.dataset.root || '/';
    const money = (c) => 'RD$ ' + (c / 100).toLocaleString('es-DO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    let product = null, chosen = [], lastFocus = null, uid = 0;

    const optionNames = (p) => p.options.map((o) => (typeof o === 'string' ? o : o.name));
    const valuesFor = (p, i) => { const out = []; p.variants.forEach((v) => { const val = v.options[i]; if (out.indexOf(val) === -1) out.push(val); }); return out; };
    const findVariant = () => product.variants.find((v) => v.options.every((o, i) => o === chosen[i]));

    function render() {
      const v = findVariant();
      if (v) {
        price.textContent = money(v.price);
        const src = (v.featured_image && v.featured_image.src) || product.featured_image;
        if (src) img.src = src;
        if (v.available) { addBtn.disabled = false; addBtn.textContent = 'Añadir al carrito'; msg.textContent = ''; }
        else { addBtn.disabled = true; addBtn.textContent = 'No disponible por ahora'; msg.textContent = 'Este tono no está disponible por el momento. Entra al producto y te avisamos cuando vuelva ♡'; }
      } else { addBtn.disabled = true; addBtn.textContent = 'No disponible'; }
    }

    function buildOptions() {
      optsBox.innerHTML = '';
      const names = optionNames(product);
      uid += 1;
      names.forEach((name, i) => {
        const fs = document.createElement('fieldset'); fs.className = 'option-group';
        const lg = document.createElement('legend'); lg.textContent = name; fs.appendChild(lg);
        const wrap = document.createElement('div'); wrap.className = 'option-values';
        valuesFor(product, i).forEach((val, k) => {
          const id = 'qa-' + uid + '-' + i + '-' + k;
          const inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'qa-opt-' + i; inp.id = id; inp.value = val; inp.checked = chosen[i] === val;
          const lb = document.createElement('label'); lb.htmlFor = id; lb.textContent = val;
          const anyAvail = product.variants.some((v) => v.options[i] === val && v.available);
          if (!anyAvail) lb.className = 'is-unavail';
          inp.addEventListener('change', () => { chosen[i] = val; render(); });
          wrap.appendChild(inp); wrap.appendChild(lb);
        });
        fs.appendChild(wrap); optsBox.appendChild(fs);
      });
    }

    async function openFor(handle, trigger) {
      lastFocus = trigger || document.activeElement;
      msg.textContent = 'Cargando…'; cartLink.hidden = true; optsBox.innerHTML = ''; title.textContent = ''; price.textContent = ''; addBtn.disabled = true;
      moreLink.href = root + 'products/' + handle;
      if (!qa.open) qa.showModal();
      document.body.style.overflow = 'hidden';
      try {
        const r = await fetch(root + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error('p');
        product = await r.json();
        const first = product.variants.find((v) => v.available) || product.variants[0];
        chosen = first.options.slice();
        title.textContent = product.title;
        msg.textContent = '';
        buildOptions(); render();
      } catch (e) {
        msg.textContent = 'No pudimos cargar las opciones. Abre el producto para elegirlas.';
      }
    }

    addBtn.addEventListener('click', async () => {
      const v = findVariant(); if (!v || !v.available) return;
      const label = addBtn.textContent; addBtn.disabled = true; addBtn.textContent = 'Añadiendo…'; msg.textContent = '';
      try {
        const r = await fetch(qa.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) });
        if (!r.ok) {
          let m = '';
          try { const j = await r.json(); m = j.description || j.message || ''; } catch (er) { /* sin detalle */ }
          const err = new Error('add'); err.userMsg = m; throw err;
        }
        const c = await (await fetch(qa.dataset.cartJs, { headers: { 'Accept': 'application/json' } })).json();
        const count = document.querySelector('.cart-btn span'); if (count) count.textContent = c.item_count;
        addBtn.textContent = 'Añadido ♡'; msg.textContent = 'Listo, lo añadimos a tu carrito ♡'; cartLink.hidden = false;
        setTimeout(() => { addBtn.disabled = false; addBtn.textContent = label; }, 2000);
      } catch (e) {
        addBtn.disabled = false; addBtn.textContent = label;
        msg.textContent = (e && e.userMsg) ? e.userMsg : 'No pudimos añadirlo. Intenta otra vez, baby.';
      }
    });

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-quick-add]');
      if (!t) return;
      e.preventDefault();
      openFor(t.dataset.quickAdd, t);
    });
    $('[data-qa-close]').addEventListener('click', () => qa.close());
    qa.addEventListener('click', (e) => { if (e.target === qa) qa.close(); });
    qa.addEventListener('close', () => { document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); });
  })();

  /* ---------- Preventa: datos de la variante elegida en el aviso ---------- */
  (function () {
    const f = document.querySelector('form[data-preventa]');
    if (!f) return;
    f.addEventListener('submit', () => {
      const root = document.querySelector('[data-product]') || document;
      const vals = Array.from(root.querySelectorAll('.option-group input[type="radio"]:checked')).map((i) => i.value);
      const variant = vals.join(' / ');
      const name = (f.querySelector('input[name="contact[Producto]"]') || {}).value || '';
      const v = f.querySelector('[data-preventa-variant]'); if (v && variant) v.value = variant;
      const b = f.querySelector('[data-preventa-body]');
      if (b) b.value = 'Preventa: ' + name + (variant ? ' (' + variant + ')' : '') + ' | Tel: ' + (f.querySelector('input[name="contact[phone]"]').value || '');
    });
  })();

  /* ---------- Recomendaciones (producto y carrito) ---------- */
  document.querySelectorAll('[data-recommendations-url]').forEach(async (el) => {
    try {
      const res = await fetch(el.dataset.recommendationsUrl);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations-url]');
      if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; el.hidden = false; }
    } catch (e) { /* si falla, la sección queda oculta */ }
  });

  /* ---------- Lista VIP: si ya está suscrita, aviso en vez de repetir ---------- */
  (function () {
    const dlg = document.getElementById('SubDialog');
    const KEY = 'se_subscribed_emails';
    const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } };
    const write = (l) => { try { localStorage.setItem(KEY, JSON.stringify(l.slice(-20))); } catch (e) { /* sin almacenamiento */ } };
    const forms = document.querySelectorAll('form[data-subscribe]');
    if (!forms.length) return;

    /* Si la página cargó con éxito, el correo pendiente pasa a la lista de suscritas */
    try {
      const pending = sessionStorage.getItem('se_sub_pending');
      if (pending && document.querySelector('.form-message--success, [data-pop-success]')) {
        const list = read(); if (list.indexOf(pending) === -1) { list.push(pending); write(list); }
        try { localStorage.setItem('se_popup_visto', String(Date.now() + 3650 * 864e5)); } catch (e) { /* ok */ }
      }
      sessionStorage.removeItem('se_sub_pending');
    } catch (e) { /* ok */ }

    const showDialog = () => {
      const pop = document.getElementById('SePopup');
      if (pop && !pop.hidden) { const c = pop.querySelector('.se-pop__close'); if (c) c.click(); }
      if (dlg && typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
      else if (dlg) { alert(dlg.querySelector('h2').textContent + ' ' + dlg.querySelector('p').textContent); }
    };
    if (dlg) {
      dlg.querySelector('[data-sub-close]').addEventListener('click', () => dlg.close());
      dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    }
    forms.forEach((form) => {
      form.addEventListener('submit', (e) => {
        const em = form.querySelector('input[type="email"]');
        if (!em) return;
        const email = em.value.trim().toLowerCase();
        const known = read().indexOf(email) > -1 ||
          (dlg && dlg.dataset.customerSubscribed === 'true' && dlg.dataset.customerEmail === email);
        if (known) { e.preventDefault(); showDialog(); return; }
        try { sessionStorage.setItem('se_sub_pending', email); } catch (er) { /* ok */ }
      });
    });
  })();

  /* ==========================================================
     Animaciones al hacer scroll (estilo Apple)
     ========================================================== */
  (function () {
    const root = document.documentElement;
    if (!root.classList.contains('anim')) return;

    const clamp01 = (n) => Math.max(0, Math.min(1, n));
    const vh = () => window.innerHeight || 800;

    /* ---- 1. Aparecer al entrar en pantalla ---- */
    const groups = [
      ['.section-head', 0], ['.hero .pill', 0], ['.hero__script', 1], ['.hero__sub', 2], ['.hero__visual', 1],
      ['.page-hero .breadcrumbs', 0], ['.page-hero__script', 1], ['.page-hero__desc', 2],
      ['.featured', 0], ['.pickup', 0], ['.footer-grid', 0], ['.reg__head', 0], ['.reg__range', 0],
      ['.products-toolbar', 0], ['.filters', 0], ['.cart-empty', 0], ['.ship-bar', 0],
      ['.product__info > *', 1], ['.product-recs, .cart__upsell', 0]
    ];
    const grids = ['.cat-grid', '.product-grid', '.babes-grid', '.article-grid', '.pickup__steps', '.cart'];
    const targets = [];
    const add = (el, i) => {
      if (!el || el.hasAttribute('data-reveal') || el.closest('[hidden]') || el.matches('.cart__summary')) return;
      if (/^(DIALOG|SCRIPT|STYLE|TEMPLATE|NOSCRIPT)$/.test(el.tagName) || el.closest('dialog')) return;
      el.setAttribute('data-reveal', '');
      el.style.setProperty('--i', String(Math.min(i, 6)));
      targets.push(el);
    };
    groups.forEach(([sel, i]) => document.querySelectorAll(sel).forEach((el, k) => add(el, sel.indexOf('>') > -1 ? k : i)));
    grids.forEach((sel) => document.querySelectorAll(sel).forEach((g) => { [...g.children].forEach((c, k) => add(c, k % 4)); }));
    /* Los que ya traen data-reveal desde el HTML */
    document.querySelectorAll('[data-reveal]').forEach((el) => { if (targets.indexOf(el) === -1) targets.push(el); });

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
      targets.forEach((el) => io.observe(el));
    } else {
      targets.forEach((el) => el.classList.add('is-in'));
    }

    /* ---- 2. Letras y palabras que se escriben al bajar ---- */
    const simple = (el) => !el.querySelector('*:not(em):not(strong):not(b):not(i):not(br):not(span)');
    function build(node, mode, out) {
      const frag = document.createDocumentFragment();
      node.childNodes.forEach((ch) => {
        if (ch.nodeType === 3) {
          ch.textContent.split(/(\s+)/).forEach((part) => {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            if (mode === 'char') {
              const w = document.createElement('span'); w.className = 'tw-word';
              Array.from(part).forEach((chr) => { const c = document.createElement('span'); c.className = 'tw-char'; c.textContent = chr; w.appendChild(c); out.push(c); });
              frag.appendChild(w);
            } else {
              const w = document.createElement('span'); w.className = 'tw-w'; w.textContent = part; frag.appendChild(w); out.push(w);
            }
          });
        } else if (ch.nodeType === 1) {
          if (ch.tagName === 'BR') frag.appendChild(ch.cloneNode());
          else { const c = ch.cloneNode(false); c.appendChild(build(ch, mode, out)); frag.appendChild(c); }
        }
      });
      return frag;
    }
    function split(el, mode) {
      if (el.dataset.tw || !simple(el)) return null;
      const label = el.textContent.replace(/\s+/g, ' ').trim();
      if (!label || label.length > (mode === 'char' ? 140 : 420)) return null;
      const out = [];
      const frag = build(el, mode, out);
      el.textContent = '';
      const sr = document.createElement('span'); sr.className = 'visually-hidden'; sr.textContent = label;
      const vis = document.createElement('span'); vis.setAttribute('aria-hidden', 'true'); vis.appendChild(frag);
      el.append(sr, vis);
      el.dataset.tw = mode;
      return out;
    }

    const scrub = [];
    const typeNow = (parts, delay, step) => {
      parts.forEach((c, i) => setTimeout(() => c.classList.add('on'), delay + i * step));
    };
    /* Título principal del inicio: se escribe solo al cargar */
    document.querySelectorAll('.hero__heading').forEach((el) => {
      const parts = split(el, 'char'); if (parts) typeNow(parts, 350, 55);
    });
    document.querySelectorAll('.hero__sub').forEach((el) => {
      const parts = split(el, 'word'); if (parts) typeNow(parts, 1000, 28);
    });
    /* Resto de títulos y textos: se escriben según bajas */
    const headSel = '.h2:not(.hero__heading), .h3, .display:not(.hero__heading), .page-hero__title, .cat-tile__title';
    document.querySelectorAll(headSel).forEach((el) => {
      if (el.closest('.cart__upsell-head, .qa, dialog')) return;
      const parts = split(el, 'char'); if (parts) scrub.push({ el, parts, n: -1, mode: 'char', once: el.matches('.cat-tile__title') });
    });
    document.querySelectorAll('.lead:not(.hero__sub), .featured__desc, .trust-card__text, .cat-tile__text').forEach((el) => {
      const parts = split(el, 'word'); if (parts) scrub.push({ el, parts, n: -1, mode: 'word', once: el.matches('.cat-tile__text') });
    });

    function updateScrub() {
      const H = vh();
      const maxScroll = Math.max(0, root.scrollHeight - H);
      const y = window.pageYOffset;
      scrub.forEach((it) => {
        const r = it.el.getBoundingClientRect();
        /* Textos de las categorías: se escriben completos al aparecer, sin quedarse a medias */
        if (it.once) {
          if (it.n !== it.parts.length && r.top < H * 0.98) {
            it.n = it.parts.length;
            typeNow(it.parts, 0, it.mode === 'char' ? 35 : 22);
          }
          return;
        }
        if (r.top > H * 1.05 && it.n === 0) return;
        if (r.bottom < -H && it.n === it.parts.length) return;
        const docTop = r.top + y;
        const minTop = Math.max(0, docTop - maxScroll);       /* lo más arriba que puede llegar en pantalla */
        const start = H * 0.92;
        const end = Math.min(Math.max(H * 0.5, minTop + 10), H * 0.82);
        let p = clamp01((start - r.top) / Math.max(40, start - end));
        if (r.top < H * 0.35) p = 1;
        const n = Math.round(p * it.parts.length);
        if (n === it.n) return;
        const from = it.n < 0 ? 0 : Math.min(it.n, n), to = it.n < 0 ? it.parts.length : Math.max(it.n, n);
        for (let i = from; i < to; i++) it.parts[i].classList.toggle('on', i < n);
        it.n = n;
      });
    }

    /* ---- 3. Paralaje del inicio y barra de progreso ---- */
    const hero = document.querySelector('.hero');
    const bar = document.querySelector('[data-scroll-progress]');
    function updateMotion() {
      const y = window.pageYOffset, H = vh();
      if (hero) hero.style.setProperty('--py', clamp01(y / Math.max(300, hero.offsetHeight)).toFixed(3));
      if (bar) bar.style.transform = 'scaleX(' + clamp01(y / Math.max(1, root.scrollHeight - H)).toFixed(4) + ')';
    }

    let raf = 0;
    const onScroll = () => { if (raf) return; raf = requestAnimationFrame(() => { raf = 0; updateScrub(); updateMotion(); }); };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', onScroll);
    updateScrub(); updateMotion();

    /* ---- 4. Números que corren (envíos desde RD$300) ---- */
    const counters = document.querySelectorAll('[data-count-to]');
    if (counters.length && 'IntersectionObserver' in window) {
      const ease = (t) => 1 - Math.pow(1 - t, 3);
      const run = (el) => {
        const to = parseFloat(el.dataset.countTo) || 0;
        const t0 = performance.now(), dur = 1900;
        cancelAnimationFrame(el._raf || 0);
        const tick = (now) => {
          const t = Math.min(1, (now - t0) / dur);
          el.textContent = Math.round(to * ease(t)).toLocaleString('es-DO');
          if (t < 1) el._raf = requestAnimationFrame(tick);
        };
        el._raf = requestAnimationFrame(tick);
      };
      counters.forEach((el) => { el.textContent = '0'; });
      const cio = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) run(en.target);
          else { cancelAnimationFrame(en.target._raf || 0); en.target.textContent = '0'; }
        });
      }, { threshold: 0.4 });
      counters.forEach((el) => cio.observe(el));
    }
  })();
});


/* ---------- «Avísame cuando llegue»: se envía sin recargar la página ----------
   Así no se activa el aviso de cumpleaños ni cualquier otro formulario de cliente de la página. */
(function () {
  const form = document.querySelector('form[data-notify]');
  if (!form) return;
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.dataset.sending === '1') return;
    const btn = form.querySelector('button[type="submit"]');
    const label = btn ? btn.textContent : '';
    const done = function () { form.dataset.sending = ''; if (btn) { btn.disabled = false; btn.textContent = label; } };
    const showError = function () {
      let err = form.querySelector('[data-notify-error]');
      if (!err) {
        err = document.createElement('p');
        err.className = 'form-message form-message--error'; err.setAttribute('role', 'alert'); err.setAttribute('data-notify-error', '');
        form.insertBefore(err, form.firstChild);
      }
      err.textContent = 'Revisa tu correo e inténtalo de nuevo.';
    };
    form.dataset.sending = '1'; if (btn) { btn.disabled = true; btn.textContent = 'Enviando…'; }
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) {
        if (/challenge/.test(r.url)) { form.dataset.sending = ''; form.submit(); return; } /* Shopify pidió verificación: envío normal */
        if (r.ok && /customer_posted=true/.test(r.url)) {
          form.innerHTML = '';
          const ok = document.createElement('p');
          ok.className = 'form-message form-message--success'; ok.setAttribute('role', 'status');
          ok.textContent = form.dataset.success || 'Listo, baby ♡ Te avisamos apenas esté disponible.';
          form.appendChild(ok);
        } else { done(); showError(); }
      })
      .catch(function () { done(); showError(); });
  });
})();

/* ---------- Favoritos del mes: flechas del carrusel ---------- */
(function () {
  function init(root) {
    var track = root.querySelector('[data-fav-track]');
    var prev = root.querySelector('[data-fav-prev]');
    var next = root.querySelector('[data-fav-next]');
    if (!track || !prev || !next) return;
    function step() { var s = track.querySelector('.fav__slide'); return s ? s.getBoundingClientRect().width + 20 : 260; }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() { document.querySelectorAll('[data-fav]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* ---------- Seguimiento: consulta por WhatsApp + encuesta + título de fecha de entrega ---------- */
(function () {
  function track() {
    var input = document.querySelector('[data-track-number]');
    var link = document.querySelector('[data-track-wa]');
    if (input && link) {
      var base = link.getAttribute('data-wa-base');
      var upd = function () {
        var n = input.value.trim();
        var msg = n ? 'Hola, quiero saber el estado de mi pedido ' + n : 'Hola, quiero saber el estado de mi pedido';
        link.href = base + '?text=' + encodeURIComponent(msg);
      };
      input.addEventListener('input', upd); upd();
    }
    var sat = document.querySelector('[data-sat]');
    if (sat) {
      var more = sat.querySelector('.sat__more');
      sat.addEventListener('change', function (e) { if (e.target.type === 'radio' && more) more.hidden = false; });
    }
  }
  function deliveryTitle() {
    if (!document.querySelector('.cart, #CartForm')) return;
    var done = false;
    function tryInsert() {
      if (done || document.querySelector('[data-date-heading]')) { done = true; return; }
      var target = document.querySelector('[class*="ds-date"],[id*="ds-date"],[class*="ds_date"],[id*="ds_date"],[class*="ds-delivery"],[id*="ds-delivery"],[class*="ds-method"],[id*="ds-method"]');
      if (!target) return;
      var h = document.createElement('p');
      h.setAttribute('data-date-heading', '');
      h.className = 'date-heading';
      h.textContent = 'Selecciona la fecha en la que deseas recibir tu pedido';
      target.parentNode.insertBefore(h, target);
      done = true;
    }
    tryInsert();
    var mo = new MutationObserver(tryInsert);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  }

  /* ---------- Promociones: carrusel de fotos ---------- */
  function promoCarousels() {
    document.querySelectorAll('[data-promo-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-promo-track]');
      var slides = root.querySelectorAll('[data-promo-slide]');
      var dots = root.querySelectorAll('[data-promo-dot]');
      var prev = root.querySelector('[data-promo-prev]');
      var next = root.querySelector('[data-promo-next]');
      if (!track || slides.length < 2) return;
      var cur = 0, ticking = false;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      }
      function paint(i) {
        cur = i;
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { ticking = false; paint(Math.round(track.scrollLeft / (track.clientWidth || 1))); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      if (prev) prev.addEventListener('click', function () { go(cur === 0 ? slides.length - 1 : cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur === slides.length - 1 ? 0 : cur + 1); });
    });
  }
  function boot() { track(); deliveryTitle(); promoCarousels(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
